import {useEffect, useRef, useState} from "react";
import {VIEW_TYPE} from '../../../../../enums/ViewType';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const TotalMealsApp = ({subViewChild, setCriteria, finalArray, setFinalArray})=> {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const prevIsDaily =  useRef(true);
    useEffect(() => {
        if(subViewChild === VIEW_TYPE.GRID.name && finalArray?.length > 0){
            setCriteria([]);
            setFinalArray([]);
        }
    }, [subViewChild, finalArray]);

    return {
        selectedDate,
        setSelectedDate,
        prevIsDaily
    }
}
